import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { getObjectiveLocale } from 'utils/HelperUtils';
const Tooltip = ({ show, backgroundClassname = 'bg-n-900', className, dataCy, portalData, tooltipId }) => {
    return (React.createElement(CSSTransition, { in: show, timeout: 300, classNames: "fade", unmountOnExit: true, appear: true },
        React.createElement("div", { "data-cy": dataCy ? dataCy : 'tooltip-portal', id: tooltipId, className: `${portalData.noWrap ? 'tooltip-portal whitespace-nowrap' : ''} tooltip-avatar pointer-events-none fixed z-9999999 rounded-lg ${backgroundClassname} px-[8px] py-[4px] text-n-000 ${className ? className : ''}`, style: {
                right: portalData.right,
                left: portalData.left,
                top: portalData.top,
                bottom: portalData.bottom,
                transform: `translate(${portalData?.translateX || 0}, ${portalData?.translateY || 0}) `
            } },
            portalData?.tooltipContent || (React.createElement("p", { className: "typography-h100 break-word whitespace-normal" }, getObjectiveLocale(portalData.name))),
            portalData.desc && React.createElement("p", null, getObjectiveLocale(portalData.desc)))));
};
const TooltipPortal = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const sharedTooltip = document.getElementById(props.portalId);
    return ReactDOM.createPortal(React.createElement(Tooltip, { ...props }), sharedTooltip);
};
export default TooltipPortal;
